import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { withRouter } from 'react-router'
import ClientsStore from '../../../stores/ClientsStore'
import LoadingWrapper from '../../../components/LoadingWrapper'
import { Button, Form, Grid, Header } from 'semantic-ui-react'
import Select from '../../../components/Forms/Select'
import ClientsAddressesEquipment from '../../../models/ClientsAddressesEquipment'
import Toast from '../../../components/Toast'

@withRouter
@observer
class InspectionsAddressesEquipmentCreateScreen extends Component {
  static propTypes = {
    match: PropTypes.object,
    history: PropTypes.object
  }

  constructor (props) {
    super(props)
    this.clientsAddressId = props.match.params.clientsAddressId || null
    this.clientsAddressEquipmentId = props.match.params.clientsAddressEquipmentId || null
    if (!this.clientsAddressId && !this.clientsAddressEquipmentId) {
      props.history.goBack()
    }
    this.isEdit = !!this.clientsAddressEquipmentId
    window.document.title = this.isEdit ? 'Modifier un équipement' : 'Ajouter un équipement'
    this.ClientsStore = new ClientsStore()
  }

  componentDidMount () {
    if (this.clientsAddressEquipmentId) {
      this.ClientsStore.loadOneInspectionAddressEquipment(this.clientsAddressEquipmentId)
    } else {
      this.ClientsStore.loadOneInspectionAddressEquipmentDependencies(this.clientsAddressId)
    }
  }

  handleSaveClientsAddressesEquipment = () => {
    const { history } = this.props
    this.ClientsStore.saveInspectionAddressEquipment(this.clientsAddressId, this.clientsAddressEquipmentId).then((result) => {
      if (result.success) {
        history.push(`/clients/view/${this.ClientsStore.clientsAddress.client_id}#${this.ClientsStore.clientsAddress.id}`)
      }
    })
  }

  render () {
    const {
      isSaving,
      isLoading,
      equipments,
      forms,
      clientsAddressesEquipment,
      clientsAddress,
      toasts
    } = this.ClientsStore
    if (isLoading) {
      return <LoadingWrapper loading={isLoading} message='Chargement en cours...' />
    }
    return (
      <>
        <LoadingWrapper loading={isSaving} message='Sauvegarde en cours...' />

        <Toast toasts={toasts} />
        <Grid columns='equal'>
          <Grid.Row>
            <Grid.Column>
              <Header as='h2'>
                {window.document.title}
              </Header>
              <Header.Subheader>
                {clientsAddress.address ? clientsAddress.address.fullAddress : ''}
              </Header.Subheader>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Form>
                <Form.Group widths='equal'>
                  <Select
                    name='clientsAddressesEquipment.equipment_id' store={this.ClientsStore}
                    onAfterChanged={() => {
                      clientsAddressesEquipment.forms.clear()
                    }}
                    label='Équipement'
                    options={equipments.map(equipment => ({ value: equipment.id, text: equipment.name }))}
                  />
                  <Select
                    multiple
                    placeholder='Veuillez sélectionner un ou plusieurs formulaires'
                    name='clientsAddressesEquipment.forms'
                    store={this.ClientsStore}
                    label='Formulaires'
                    options={forms
                      .filter(form => form.equipment_id === clientsAddressesEquipment.equipment_id)
                      .map(form => ({ value: form.code, text: `${form.code} : ${form.name}` }))}
                  />
                </Form.Group>
                <Form.Group>
                  <Select
                    width='8'
                    name='clientsAddressesEquipment.inspection_frequency' store={this.ClientsStore}
                    label="Fréquence d'inspection" options={Object.entries(ClientsAddressesEquipment.INSPECTION_FREQUENCY)
                      .map(entry => ({ value: entry[0], text: entry[1] }))}
                  />
                </Form.Group>
              </Form>
            </Grid.Column>
          </Grid.Row>
          <Grid.Column>
            <Button
              disabled={!this.ClientsStore.clientsAddressesEquipment.isDirty}
              content='Enregistrer'
              primary
              onClick={this.handleSaveClientsAddressesEquipment}
            />
          </Grid.Column>
        </Grid>
      </>
    )
  }
}

export default InspectionsAddressesEquipmentCreateScreen
